import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export var observable = typeof _Symbol === 'function' && _Symbol.observable || '@@observable';